// extracted by mini-css-extract-plugin
module.exports = {"episodeWrapper":"index-module--episode-wrapper--2J9h0","textItalic":"index-module--text-italic--2FeNG","textBlue":"index-module--text-blue--1mpfc"};